import { businessKey } from 'queryKeys';

export const ADMIN_USERS = 'AdminUsers';
export const adminUsersQuery = businessKey.query(ADMIN_USERS);
const MUTATION_PERMISSIONS = 'updatePermissions';

export const grids = adminUsersQuery.grids();
export const grid = adminUsersQuery.grid();

export const details = adminUsersQuery.details();
export const model = adminUsersQuery.exact();

const MUTATION_BLOCK = 'block';
const MUTATION_UNBLOCK = 'unblock';
const MUTATION_EXPORT = 'export';

export const mutations = adminUsersQuery.mutations();
export const create = mutations.create();
export const update = mutations.update();

export const block = mutations.mutate(MUTATION_BLOCK);
export const unblock = mutations.mutate(MUTATION_UNBLOCK);
export const exportAU = mutations.mutate(MUTATION_EXPORT);
export const updateUsersPermissions = mutations.mutate(MUTATION_PERMISSIONS);
